import { connect } from 'react-redux';

import Content from './Content';
import { getContentList, changeContentStatus, deleteContent, getAgeGroups } from './action';


const mapStateToProps = (state) => {
		var stateData = {
			requestProcess: state.authorContent.requestProcess
		};

		if(state.authorContent.data){
			stateData['data'] = state.authorContent.data;
		}

		if(state.category.addUpdateCategory){
			stateData['statusChange'] = state.category.addUpdateCategory;
		}


		if(state.authorContent.updateContent){
			stateData['statusChange'] = state.authorContent.updateContent;
		}
		return stateData;
};

const mapDispatchToProps = (dispatch) => {
	return {
		_getContentList: (params) => {
			dispatch(getContentList(params));
		},

		_changeContentStatus: (params) => {
				dispatch(changeContentStatus(params))
		},

		_deleteContent: (params) => {
			dispatch(deleteContent(params))
		},
		_getAgeGroups: () => {
			return getAgeGroups();
		}


	}
};


export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Content);
